module.exports = __webpack_public_path__ + "img/poucevert_on.b2e5f5e7.gif";